import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { DIRECTED_WIZARD_STEPS, directedStepIndex } from '../directedSteps';
import { useDirectedVideoContext } from '../DirectedVideoContext';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface DirectedStepLayoutProps {
  /** The side panel (design `.dv-side`); none: the step uses the whole width. Hidden on a phone. */
  side?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The body of one step (design `.dv-body`): the step on the left, the side panel on the right. On a
 * phone (design j) one column with the step bars at the top; the foot of the step sticks to the
 * bottom.
 */
const DirectedStepLayoutComponent: React.FC<DirectedStepLayoutProps> = ({ side, children }) => {
  const { screen } = useDirectedVideoContext();
  const shownIndex = directedStepIndex(screen);
  return (
    <div className={clsx(styles.body, side === undefined && styles.bodyOne)}>
      <main className={styles.main}>
        <div className={styles.phoneSteps} aria-hidden>
          {DIRECTED_WIZARD_STEPS.map((step, index) => (
            <i key={step} className={clsx(index <= shownIndex && styles.phoneStepOn)} />
          ))}
        </div>
        {children}
      </main>
      {side !== undefined && <aside className={styles.side}>{side}</aside>}
    </div>
  );
};

export const DirectedStepLayout = TypedMemo(DirectedStepLayoutComponent);
